/**
 * List controller.
 *
 * This class handles the filtering of items on views with ListSearch filtering.
 * Uses list.js: https://listjs.com/
 */

import List from 'list.js';

/**
 * Class List.
 */
class ListSearch {

    /**
     * Init the List.
     */
    init() {
        const options = {
            valueNames: [
                'agent-name',
                'agent-area'
            ]
        };

        this.userList = new List('agents', options);
    }

    /**
     * Run when the document is ready.
     */
    docReady() {

     this.init();

     document.getElementById('agents-search').addEventListener('input', (event) => {

        var searchTerm = event.target.value.toLowerCase();

        this.userList.filter((item) => {
            // Get the agent-area value and split into an array
            let areas = item.values()['agent-area'].toLowerCase().split(', ');

            // Get the agent-name value and split into first & last name
            let nameParts = item.values()['agent-name'].toLowerCase().split(' ');

            // Check if the first or last name starts with searchTerm
            let nameMatches = nameParts.some(part => part.startsWith(searchTerm));

            // Check if any of the areas start with searchTerm
            let areaMatches = areas.some(area => area.startsWith(searchTerm));

            // Return true if either name or area matches
            return nameMatches || areaMatches;
        });
    });

    }

}

// Export the class reference.
module.exports = ListSearch;



// WEBPACK FOOTER //
// ./assets/scripts/list.js